import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { DEFAULT_CREATE_SEND_CLAIM_PAGE_STATE } from '../../../constants/createSendClaimPage';
import { ICreateSendClaimPageState } from '../../../types/createSendClaimPage';
import * as AuthActions from '../../actions/auth';
import * as ClaimPageActions from '../actions/claimPage';
import * as ContentsActions from '../actions/contents';

export const initialState: ICreateSendClaimPageState = DEFAULT_CREATE_SEND_CLAIM_PAGE_STATE;

const reducer = (state: ICreateSendClaimPageState = initialState, action: any): ICreateSendClaimPageState => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT: {
      return initialState;
    }
    case ContentsActions.TOGGLE_CS_KIT:
    case ContentsActions.SET_CS_GIFT_CHOICE_MODE:
    case ContentsActions.RESET_CS_CUSTOM_KIT: {
      return { ...state, experienceId: undefined };
    }
    case ClaimPageActions.SET_CS_CLAIM_PAGE_EXPERIENCE_ID: {
      return { ...state, experienceId: action.payload };
    }
    default:
      return state;
  }
};

export default reducer;
